"use client"

import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"
import { debounce } from "lodash-es"

/**
 * Tracks search queries and the number of search results
 * as posthog events by hooking into the nextra search input
 * events.
 */
export const PHSearchTracker = () => {
  const posthog = usePostHog()

  useEffect(() => {
    const searchInput = document.querySelector("input[type='search']")
    if (!searchInput) {
      console.error("Couldn't find any input[type='search']")
      return
    }

    const onSearchInput = (e: Event) => {
      const target = e.target as HTMLInputElement
      if (target.value.length >= 2) {
        const headerNav = document.querySelector("nav")
        if (!headerNav) {
          console.error("Couldn't find the header nav")
          return
        }

        // Nextra doesn't have many semantic class names so this
        // selector is potentially brittle, keep an eye on it
        const searchResultEls = headerNav.querySelectorAll(
          "ul.nextra-scrollbar li",
        )

        posthog.capture("search_query", {
          query: target.value,
          results: searchResultEls.length,
        })
      }
    }

    // Debounce the event to wait for the user to stop typing
    // and the search results to appear
    const debouncedHandler = debounce(onSearchInput, 500)

    searchInput.addEventListener("input", debouncedHandler)

    return () => {
      searchInput.removeEventListener("input", debouncedHandler)
    }
  }, [posthog])

  return null
}
